/* Zumpo/Trios card. Outlines are inset shadows, so a pick never moves the
   cards beside it. */
.card {
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: var(--zumpo-space-12);
  width: 192px;
  height: 128px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: var(--zumpo-radius-16);
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 1px var(--zumpo-line);
  background: var(--zumpo-paper);
  color: var(--zumpo-ink);
}

.compact {
  gap: var(--zumpo-space-8);
  width: 110px;
  height: 76px;
  border-radius: var(--zumpo-radius-12);
}

.mini {
  gap: var(--zumpo-space-4);
  width: 72px;
  height: 48px;
  border-radius: var(--zumpo-radius-8);
}

/* Picked: it lifts off the table. */
.selected {
  box-shadow:
    var(--zumpo-shadow-paper-lift),
    inset 0 0 0 3px var(--zumpo-ink);
}

/* Found: the paper stays, so every shape keeps its full contrast; the ring
   and the finder's tag mark it. */
.found {
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 3px var(--zumpo-green);
}

.wrong {
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 3px var(--zumpo-danger);
}

/* Hinted: a lime ring, as a highlighter would mark it, and a lime badge. */
.hinted {
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 4px var(--zumpo-lime);
}

.compact.hinted {
  box-shadow:
    var(--zumpo-shadow-cell-edge),
    inset 0 0 0 3px var(--zumpo-lime);
}

/* "Hint", or the finder's initials, on the top right corner. */
.badge {
  position: absolute;
  top: -10px;
  right: 10px;
  padding: var(--zumpo-space-1) var(--zumpo-space-8);
  border-radius: var(--zumpo-radius-999);
  background: var(--zumpo-ink);
  color: var(--zumpo-paper);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
  white-space: nowrap;
}

.mini .badge {
  right: var(--zumpo-space-4);
}

.found .badge {
  background: var(--zumpo-green);
}

.hinted .badge {
  background: var(--zumpo-lime);
  color: var(--zumpo-ink);
}

.button {
  cursor: pointer;
  touch-action: manipulation;
}

/* Hover lifts the card without an outline, so a card under the pointer never
   looks picked, even just after three went back. Only where there is a
   pointer to hover with: on a touch screen the hover sticks after a tap. */
@media (hover: hover) {
  .button:hover:not(:disabled, .selected, .found, .wrong, .hinted) {
    box-shadow:
      var(--zumpo-shadow-paper-lift),
      inset 0 0 0 1px var(--zumpo-line);
  }

  .button.hinted:hover:not(:disabled) {
    box-shadow:
      var(--zumpo-shadow-paper-lift),
      inset 0 0 0 4px var(--zumpo-lime);
  }

  .button.compact.hinted:hover:not(:disabled) {
    box-shadow:
      var(--zumpo-shadow-paper-lift),
      inset 0 0 0 3px var(--zumpo-lime);
  }
}

.button:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.button:disabled {
  cursor: default;
}
